import React from "react";
import { FaLocationDot } from "react-icons/fa6";
import { Skeleton, Box, Stack } from "@mui/material";
import { FaCalendarCheck } from "react-icons/fa6";
import { format } from "date-fns";
import { CiWarning } from "react-icons/ci";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { getAssetScanStatusBadge } from "../../utilities";

// function ScannedAssetCard1({ data }) {
//   const asset = data.asset;

//   return (
//     <div className="col-md-4">
//       <div
//         className="card shadow-sm border-0 mb-3 p-2"
//         style={{ overflow: "hidden" }}
//       >
//         <div className="d-flex align-items-center gap-3">
//           <div
//             className="card rounded-2 overflow-hidden"
//             style={{ height: "150px", width: "150px" }}
//           >
//             {asset?.image ? (
//               <img
//                 src={asset.image}
//                 alt={asset.name}
//                 style={{
//                   objectFit: "contain",
//                   maxHeight: "150px",
//                   width: "100%",
//                   display: "block",
//                   margin: "0 auto",
//                 }}
//               />
//             ) : (
//               <div
//                 className="d-flex justify-content-center align-items-center text-white fs-5"
//                 style={{
//                   height: "100%",
//                   width: "100%",
//                   backgroundColor: "#adb5bd",
//                   fontSize: "1.1rem",
//                   fontWeight: 500,
//                 }}
//               >
//                 No Image
//               </div>
//             )}
//           </div>
//           <div className="flex-grow-1 d-flex flex-column justify-content-between">
//             <div className="d-flex flex-wrap gap-2 justify-content-between">
//               <div>
//                 <h5 className="mb-1">
//                   {asset?.name}{" "}
//                   <small className="text-muted">({asset?.brand})</small>
//                 </h5>
//                 <p className="small mb-2">
//                   <FaLocationDot className="me-1 text-danger" />
//                   {asset?.current_location || "-"}
//                 </p>
//               </div>
//               <span
//                 className={`align-self-start badge ${getStatusBadge(
//                   data?.status
//                 )}`}
//                 style={{ padding: "0.4rem 0.8rem" }}
//               >
//                 {data.status}
//               </span>
//             </div>
//             <div className="d-flex flex-wrap mb-2">
//               <div className="me-2">
//                 <span
//                   className="text-dark fw-medium me-1"
//                   style={{ fontSize: "0.85rem" }}
//                 >
//                   Asset ID:
//                 </span>
//                 <span className="fw-medium text-darker">
//                   {asset?.manual_asset_id || "-"}
//                 </span>
//               </div>

//               <div className="me-3">
//                 <span
//                   className="text-dark fw-medium me-1"
//                   style={{ fontSize: "0.85rem" }}
//                 >
//                   Allocate To:
//                 </span>
//                 <span className="fw-medium text-darker">
//                   {asset?.responsible_user?.name || "-"}
//                 </span>
//               </div>
//             </div>
//             <div className="small">
//               <FaCalendarCheck className="me-1 text-primary" />
//               {data.scanned_at
//                 ? format(new Date(data.scanned_at), "dd MMM yyyy, hh:mm a")
//                 : "-"}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

function ScannedAssetCard({ data }) {
  const asset = data.asset;

  return (
    <div className="col-md-6 col-lg-4">
      <div
        className="card shadow-sm border-0 h-100"
        style={{ overflow: "hidden" }}
      >
        <div className="p-2 border-bottom d-flex justify-content-between flex-wrap">
          {getAssetScanStatusBadge(data.status)}
          <div>
            <span
              className="text-dark fw-medium"
              style={{ fontSize: "0.9rem" }}
            >
              {asset?.rfid_tag_id || "-"}
            </span>
          </div>
        </div>
        <div className="card-body">
          <div className="d-flex gap-3">
            <div
              className="card rounded-2 overflow-hidden"
              style={{ height: "110px", width: "120px" }}
            >
              {asset?.image ? (
                <img
                  src={`${process.env.REACT_APP_BASE_URL}${asset?.image}`}
                  alt={asset.name}
                  style={{
                    objectFit: "contain",
                    maxHeight: "110px",
                    width: "100%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center text-white fs-5"
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "#adb5bd",
                    fontSize: "1.1rem",
                    fontWeight: 500,
                  }}
                >
                  No Image
                </div>
              )}
            </div>
            <div>
              <h5 className="m-0">{asset?.name || "-"} </h5>
              <div>
                <span
                  className="text-dark fw-medium me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  Brand:
                </span>
                <span
                  className="text-dark fw-medium me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  {asset?.brand || "-"}
                </span>
              </div>
              <div>
                <FaLocationDot size={12} className="text-danger me-1" />
                <span
                  className="text-dark fw-medium me-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  {asset?.current_location || "-"}
                </span>
              </div>
              <div>
                <span
                  className="text-dark fw-medium me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  Assign To:
                </span>
                <span
                  className="text-dark fw-medium me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  {asset?.responsible_user?.name || "-"}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-2 d-flex gap-1">
            <div className="flex-fill">
              <div>
                <span
                  className="text-dark fw-medium"
                  style={{ fontSize: "0.85rem" }}
                >
                  Asset ID :
                </span>
                <br></br>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {asset?.manual_asset_id || "-"}
                </span>
              </div>
              <div>
                <span
                  className="text-dark fw-medium"
                  style={{ fontSize: "0.85rem" }}
                >
                  Last Scan :
                </span>
                <br></br>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {data.scanned_at
                    ? format(new Date(data.scanned_at), "dd MMM yyyy, hh:mm a")
                    : "-"}
                </span>
              </div>
            </div>
            <div className="flex-fill">
              <div>
                <span
                  className="text-dark fw-medium"
                  style={{ fontSize: "0.85rem" }}
                >
                  Allocated Area :
                </span>
                <br></br>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {asset?.allocated_area || "-"}
                </span>
              </div>
              <div>
                <span
                  className="text-dark fw-medium"
                  style={{ fontSize: "0.85rem" }}
                >
                  Auditor :
                </span>
                <br></br>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {data?.auditor?.name || "-"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function AssetCardSkeleton() {
  return (
    <div className="col-md-6 col-lg-4">
      <div
        className="card shadow-sm border-0 h-100"
        style={{ overflow: "hidden" }}
      >
        {/* ✅ Top Row */}
        <div className="p-2 border-bottom d-flex justify-content-between align-items-center">
          <Skeleton
            variant="rounded"
            width="30%" // ✅ % instead of fixed px
            height={24}
            animation="wave"
            style={{ borderRadius: "12px" }}
          />
          <Skeleton variant="text" width="20%" height={20} animation="wave" />
        </div>

        <div className="card-body">
          <div className="d-flex gap-3">
            {/* ✅ Image */}
            <Box
              sx={{
                flexShrink: 0,
                width: { xs: 90, sm: 100, md: 120 }, // ✅ responsive width
                height: { xs: 80, sm: 100, md: 110 }, // ✅ responsive height
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="wave"
              />
            </Box>

            {/* ✅ Text Section */}
            <Box sx={{ flexGrow: 1, minWidth: "50%" }}>
              <Skeleton
                variant="text"
                width="80%"
                height={26}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="60%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="70%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="75%"
                height={20}
                animation="wave"
              />
            </Box>
          </div>

          {/* ✅ Bottom Section */}
          <div className="my-3 d-flex gap-3 flex-wrap">
            {/* LEFT COLUMN */}
            <div className="flex-fill">
              <Skeleton
                variant="text"
                width="60%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="80%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="50%"
                height={18}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="85%"
                height={20}
                animation="wave"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="flex-fill">
              <Skeleton
                variant="text"
                width="60%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="80%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="50%"
                height={18}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="85%"
                height={20}
                animation="wave"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const ScanAuditAsset = ({
  isVerified,
  assetData,
  scanLoading,
  verifyModalOpen,
}) => {
  return (
    <div className="container fluid">
      {isVerified ? (
        <div className="row g-2">
          {scanLoading && <AssetCardSkeleton />}

          {assetData.map((item, idx) => (
            <ScannedAssetCard key={idx} data={item} />
          ))}
        </div>
      ) : (
        <div className="text-center mt-3">
          <p className="text-small">
            Please verify to access scanning features.
          </p>
          <button onClick={verifyModalOpen} className="btn btn-outline-primary">
            Verify
          </button>
        </div>
      )}
    </div>
  );
};

export default ScanAuditAsset;
